<template>
  <b-form-group
    :label="label"
  >
    <v-select
      :name="name"
      :value="optionSelected"
      :options="institutionTypesState.list"
      :class="{ 'v-select-danger': danger, 'select-size-sm': small }"
      :disabled="isDisabled"
      @input="onInput"
    >
      <template #spinner>
        <b-spinner
          small
          v-if="institutionTypesState.loading"
          :style="{ opacity: institutionTypesState.loading ? 1 : 0 }"
          variant="primary"
        />
      </template>
      <template slot="no-options">
        no hay tipos de institución para el criterio de búsqueda
      </template>
    </v-select>
    <div
      v-if="danger"
      class="con-text-validation span-text-validation-danger v-enter-to"
      style="height: 19px;">
      <span class="span-text-validation">
        {{ dangerText }}
      </span>
    </div>
  </b-form-group>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('List', [
      'institutionTypesState'
    ]),
    optionSelected() {
      return this.institutionTypesState.list.find((option) => option.value === this.value);
    },
    isDisabled() {
      return this.disabled
        || !this.institutionTypesState.list.length
        || this.institutionTypesState.loading;
    }
  },
  methods: {
    ...mapActions('List', [
      'fetchInstitutionTypes'
    ]),
    onInput(event) {
      this.$emit('input', event?.value);
    },
    getOption() {
      return this.institutionTypesState.list.find((option) => option.value === this.value);
    }
  },
  created() {
    this.fetchInstitutionTypes();
  },
  props: {
    name: { type: String, required: true },
    label: { type: String, default: 'Tipo Institución' },
    value: { type: String },
    danger: { type: Boolean },
    dangerText: { type: String },
    disabled: { type: Boolean, default: false },
    block: { type: Boolean, default: true },
    small: { type: Boolean, default: false }
  }
};

</script>
